import { useQuery } from "@tanstack/react-query";
import { Select } from "antd";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { getGiftCard } from "../../network/Sales";
import SubInfo from "../admin/common/SubInfo";

type Props = { giftCard: any; setGiftCard: any };

const SelectGiftCardSale = ({
  giftCard: GiftCardSelected,
  setGiftCard,
}: Props) => {
  const intl = useIntl();

  const { locationId } = useSelector((state: any) => state.calendar);
  const [searchValue, setSearchValue] = useState("");
  const handleAddGiftCard = (membershipId: number): void => {
    if (!GiftCardSelected) return; // return if no product matches the ID
    const targetObject = giftCards?.data[0]?.values.find(
      (obj: any) => obj.id === membershipId
    );

    const newGiftCard = {
      ...GiftCardSelected,
      itemable_id: membershipId,
      itemable_type: "gift_card",
      quantity: 1,
      price: targetObject?.value,
      voucher_duration: giftCards?.data[0]?.voucher_duration?.days_difference,
    };
    setGiftCard((prevGiftCards: any) => [...prevGiftCards, newGiftCard]);
  };

  const {
    data: giftCards,
    isLoading,
    isSuccess,
    isError,
  } = useQuery(["sales"], () => getGiftCard(locationId));
  const options =
    isLoading ||
    giftCards?.data[0]?.values?.map((giftCard: any) => {
      if (GiftCardSelected.find((s: any) => s.itemable_id === giftCard.id)) {
        return {
          label: (
            <div
              className="flex flex-col justify-between p-1"
              key={giftCard?.id}
            >
              <p>كارت هدايا #{giftCard.id}</p>
              <div className="flex items-center justify-between">
                <SubInfo
                  titleClassName="text-black font-base"
                  value={
                    giftCards?.data[0]?.voucher_duration?.days_difference.split(
                      " "
                    )[0]
                  }
                  label={intl.formatMessage({
                    id: "day",
                    defaultMessage: "يوم",
                  })}
                />
                <SubInfo
                  value={giftCard?.value}
                  label={intl.formatMessage({
                    id: "SAR",
                    defaultMessage: "ريال سعودي",
                  })}
                />
              </div>
            </div>
          ),
          value: giftCard?.id,
          key: giftCard?.id,
          disabled: true,
        };
      } else {
        return {
          label: (
            <div
              className="flex flex-col justify-between p-1"
              key={giftCard?.id}
            >
              <p>كارت هدايا #{giftCard.id}</p>
              <div className="flex items-center justify-between">
                <SubInfo
                  titleClassName="text-black font-base"
                  value={
                    giftCards?.data[0]?.voucher_duration?.days_difference.split(
                      " "
                    )[0]
                  }
                  label={intl.formatMessage({
                    id: "day",
                    defaultMessage: "يوم",
                  })}
                />
                <SubInfo
                  value={giftCard?.value}
                  label={intl.formatMessage({
                    id: "SARshort",
                    defaultMessage: "ريال سعودي",
                  })}
                />
              </div>
            </div>
          ),
          value: giftCard?.id,
          key: giftCard?.id,
          disabled: false,
        };
      }
    });

  return (
    <Select
      className="w-full"
      onSearch={(value: any) => {
        setSearchValue(value);
      }}
      onChange={(value) => {
        handleAddGiftCard(value);
        if (value && searchValue) {
          setSearchValue("");
        }
      }}
      labelRender={(option: any) => (
        <div className="flex items-center justify-between">
          <p>كارت هدايا #{option?.value}</p>
          <div></div>
        </div>
      )}
      showSearch
      placeholder={intl.formatMessage({ id: "addGiftCardPlaceholder" })}
      filterOption={false}
      options={options}
    />
  );
};

export default SelectGiftCardSale;
